module.exports = __webpack_public_path__ + "static/media/uxdesign.b0b2e52e.png";